<template>
  <div>
    <b-modal :title="'اضافه کردن'" id="homeCategoryModal" v-model="showModal" no-close-on-esc header-close-variant="dark" hide-footer centered>
      <div class="d-flex flex-column gap-3">
        <ComboBox
          isReadOnly
          :searchedData="categoryType"
          title="دسته بندی"
          placeholder="دسته بندی"
          :selectedValue="selectedCategory"
          @select="selectCategory($event)"
          :inputStyle="comboStyle"
        />

        <TextAreaInput
          :value="selectedHomeCategory.title"
          @input="selectedHomeCategory.title = $event"
          title="عنوان"
          rows="2"
          :maxlength="10000"
          placeholder="عنوان"
          labelClass="labelClass"
        />

        <BaseText :value="selectedHomeCategory.link" @input="selectedHomeCategory.link = $event" title="لینک " placeholder="لینک" :maxlength="10000" labelClass="labelClass" />

        <div class="d-flex justify-content-end align-items-center mt-3 gap-2">
          <b-button variant="secondary" @click="hideModal">انصراف</b-button>

          <Button @click.native="StoreHomeCategory" :loading="loading" text="ثبت" btnClass="upload-btn btn-border" />
        </div>
      </div>
    </b-modal>

    <Toast title="بیشتر از هفت عنوان قابل اضافه کردن نیست.برای اضافه کردن یکی از موارد را حذف کنید." error :showToast="showError" />
  </div>
</template>

<script>
import Toast from '../../common/Toast.vue'
import Button from '../../common/Button.vue'
import BaseText from '../../common/form/formModules/BaseText.vue'
import dadbananSettingProvider from '../../../services/dadban/banners'
import ComboBox from '../../../components/common/form/formModules/ComboBox.vue'
import TextAreaInput from '../../common/form/formModules/TextAreaInput.vue'

export default {
  name: 'FirstBannerModal',
  components: { BaseText, Button, ComboBox, Toast, TextAreaInput },
  props: {
    homeCategory: {
      type: Object,
      default: () => {},
    },
  },
  data: () => {
    return {
      showError: false,
      selectedHomeCategory: {
        link: '',
        title: '',
        id: undefined,
        category: null,
      },
      loading: false,
      showModal: false,
      selectedCategory: '',
      comboStyle: 'color: #495057',
      categoryType: [
        { key: 0, value: 'دوره های حضوری' },
        { key: 1, value: 'دوره های آنلاین' },
        { key: 2, value: 'دوره های آفلاین' },
        { key: 3, value: 'کتب کاربردی' },
      ],
    }
  },
  watch: {
    homeCategory(val) {
      if (val) this.selectedHomeCategory = val
      this.selectedCategory = this.categoryType.find((item) => item.key === val.category).value
    },
    showModal(val) {
      if (!val) {
        this.showError = false
        this.selectedCategory = ''
        this.selectedHomeCategory = {}
      }
    },
  },
  methods: {
    hideModal() {
      this.$bvModal.hide('homeCategoryModal')
      this.selectedHomeCategory = {}
      this.selectedCategory = ''
    },
    selectCategory(e) {
      if (!e) {
        this.selectedHomeCategory.category = null
        return false
      }
      this.selectedHomeCategory.category = this.categoryType.find((item) => item.value === e).key
      this.selectedCategory = this.categoryType.find((item) => item.value === e).value
    },
    async StoreHomeCategory() {
      this.showError = false
      let result
      this.loading = true
      try {
        if (this.selectedHomeCategory.id) result = await dadbananSettingProvider.updateHomeCategory(this.selectedHomeCategory)
        else result = await dadbananSettingProvider.insertHomeCategory(this.selectedHomeCategory)

        if (result.status >= 200 || result.status <= 204) {
          this.$emit('update')
          this.showModal = false
          this.selectedHomeCategory = {}
        }
        this.loading = false
      } catch (error) {
        this.loading = false
        this.showError = true
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.upload-btn {
  margin-right: 10px !important;
  background: #556ee6 !important;
  border-radius: 4px !important;
  color: white !important;
  padding: 8px 28px !important;
}
</style>
